module.exports = __webpack_public_path__ + "a3f945638e08b2e99a6589abe65169c7.svg";